import {makeAutoObservable} from "mobx";
import IframeService, {LARAVEL_TYPE} from "../../../../services/iframe-service/iframe-service";
import {rootContainer, TYPE} from "../../../../services/container/root";
import config from "../../../../config";
import {APP_PATHS} from "../../../../constants/app-paths";

export enum LARAVEL_APP_PATH_PATTERN {
    DASHBOARD = '/dashboard',
    SHIP_BY_RETURNGO = '/dashboard/ship-by-returngo',
    RETURN_COVERAGE = '/dashboard/return-guard',
    SETTINGS_RETURN_REASONS = '/dashboard/settings/return-reasons',
    SETTINGS_RETURNS = '/dashboard/returns',
    SETTINGS_RETURNS_NEW = '/dashboard/returns-new',
    SETTINGS_RESOLUTIONS = '/dashboard/settings/resolutions',
    SETTINGS_GENERAL = '/dashboard/settings/store',
    SETTINGS_LANGUAGES = '/dashboard/settings/portal-and-emails-languages',
    SETTINGS_RETURN_METHODS = '/dashboard/settings/return-methods',
    SETTINGS_RETURN_POLICIES = '/dashboard/settings/policy-rules',
    SETTINGS_PORTAL_CONTENT = '/dashboard/settings/portals/content',
    SETTINGS_PORTAL_LOOK_AND_FEEL = '/dashboard/settings/return-portal/look-and-feel',
    SETTINGS_EMAILS_CONTENT = '/dashboard/settings/email/email-content',
    SETTINGS_EMAILS_LOOK_AND_FEEL = '/dashboard/settings/email/customize-emails',
    SETTINGS_EMAILS_NOTIFICATIONS = '/dashboard/settings/email/notifications',
    SETTINGS_INTEGRATIONS = '/dashboard/settings/integrations/products-services',
    SETTINGS_API = '/dashboard/settings/integrations/api',
    BACK_TO_SYS_ADMIN = '/login-as-admin',
    PROFILE = '/dashboard/profile',
    BILLING = '/dashboard/billing',
    SUBSCRIPTION_PLANS = '/dashboard/subscription-plans',
    STORE_ACCOUNTS = '/dashboard/accounts',
    TROUBLESHOOTING = '/admin/troubleshooting',
    ANALYTICS_RETURNS = '/dashboard/analytics-returns',
    ANALYTICS_ORDERS = '/dashboard/analytics-orders',
    ANALYTICS_SESSIONS = '/dashboard/analytics-sessions',
    ANALYTICS_CREDITS = '/dashboard/analytics/credits',
    ANALYTICS_TRANSACTIONS = '/dashboard/analytics/transactions',
    ANALYTICS_SHIPMENTS = '/dashboard/analytics/shipments',
    ACCOUNT_HEALTH_PAGE = '/admin/account-health',
    LOCALIZATION_STOREFRONT = '/dashboard/settings/store-front/localization-page',
    LOCALIZATION_RETURN_PORTAL = '/dashboard/settings/return-portal/localization-page',
    LOCALIZATION_RETURN_METHODS = '/dashboard/settings/return-methods/localization-page',
    LOCALIZATION_EMAILS = '/dashboard/settings/email/localization-page',
    LOCALIZATION_TRACKING_EMAILS = '/dashboard/settings/tracking-emails/localization-page',
    CREATE_RMA = '/dashboard/returns/create-rma',
    USER_MASTER_LIST = '/admin/users',
    CHOOSE_STORE_LOCATION = '/choose-store-location',
    ADMIN_MANAGE_PLANS = '/admin/manage-plans',
    ADMIN_MANAGE_MERCHANTS_PLANS = '/admin/manage-merchants-plans',
    ADMIN_MIGRATE_GLOBAL_E_MERCHANTS = '/admin/migrate-global-e-merchants',
    ADMIN_DEV_SETTINGS = '/dashboard/dev-settings',
    SETTINGS_EMAILS_VARIABLES_AND_EVENTS = '/dashboard/settings/email/email-content',
    SETTINGS_INTEGRATIONS_BASE = '/dashboard/settings/integrations',
    WIDGETS_REPORT_SHIPMENT = '/dashboard/shipments-old',
    WIDGETS_REPORT_BILLING = '/admin/billing',
    WIDGETS_REPORT_RETURNS = '/dashboard/returns',
    WIDGETS_REPORT_TRACKING = '/dashboard/shipments-old',
    ONBOARDING = '/dashboard',
}

export const SPA_APP_PATH_PATTERN = {
    DASHBOARD: APP_PATHS.DASHBOARD,
    RETURNS: APP_PATHS.RETURNS,
    RETURNS_NEW: APP_PATHS.RETURNS_NEW,
    SHIP_BY_RETURNGO: APP_PATHS.SHIP_BY_RETURNGO,
    RETURN_COVERAGE: APP_PATHS.RETURN_COVERAGE,
    SETTINGS_GENERAL: APP_PATHS.SETTINGS_GENERAL,
    SETTINGS_LANGUAGES: APP_PATHS.SETTINGS_LANGUAGES,
    SETTINGS_RETURN_REASONS: APP_PATHS.RETURN_REASONS,
    SETTINGS_RESOLUTIONS: APP_PATHS.RESOLUTIONS,
    SETTINGS_RETURN_METHODS: APP_PATHS.RETURN_METHODS,
    SETTINGS_RETURN_POLICIES: APP_PATHS.POLICY_RULES,
    SETTINGS_PORTAL_CONTENT: APP_PATHS.SETTINGS_PORTAL_CONTENT,
    SETTINGS_PORTAL_LOOK_AND_FEEL: APP_PATHS.LOOK_AND_FEEL,
    SETTINGS_EMAILS_CONTENT: APP_PATHS.EMAIL_CONTENT,
    SETTINGS_EMAILS_LOOK_AND_FEEL: APP_PATHS.EMAIL_LOOK_AND_FEEL,
    SETTINGS_EMAILS_NOTIFICATIONS: APP_PATHS.EMAIL_NOTIFICATIONS,
    SETTINGS_INTEGRATIONS: APP_PATHS.INTEGRATIONS_PRODUCTS_SERVICES,
    SETTINGS_API: APP_PATHS.INTEGRATIONS_API,
    BACK_TO_SYS_ADMIN: '/login-as-admin',
    PROFILE: APP_PATHS.PROFILE,
    BILLING: APP_PATHS.BILLING,
    SUBSCRIPTION_PLANS: APP_PATHS.SUBSCRIPTION_PLANS,
    STORE_ACCOUNTS: APP_PATHS.ADMIN_ACCOUNTS,
    TROUBLESHOOTING: APP_PATHS.ADMIN_TROUBLESHOOTING,
    ANALYTICS_RETURNS: APP_PATHS.ANALYTICS_RETURNS,
    ANALYTICS_ORDERS: APP_PATHS.ANALYTICS_ORDERS,
    ANALYTICS_SESSIONS: APP_PATHS.ANALYTICS_SESSIONS,
    ANALYTICS_CREDITS: APP_PATHS.ANALYTICS_CREDITS,
    ANALYTICS_TRANSACTIONS: APP_PATHS.ANALYTICS_TRANSACTIONS,
    ANALYTICS_SHIPMENTS: APP_PATHS.ANALYTICS_SHIPMENTS,
    ACCOUNT_HEALTH_PAGE: APP_PATHS.ADMIN_ACCOUNT_HEALTH,
    LOCALIZATION_STOREFRONT: APP_PATHS.STOREFRONT_LOCALIZATION,
    LOCALIZATION_RETURN_PORTAL: APP_PATHS.RETURN_PORTAL_LOCALIZATION,
    LOCALIZATION_RETURN_METHODS: APP_PATHS.RETURN_METHODS_LOCALIZATION,
    LOCALIZATION_EMAILS: APP_PATHS.EMAILS_LOCALIZATION,
    LOCALIZATION_TRACKING_EMAILS: APP_PATHS.TRACKING_EMAILS_LOCALIZATION,
    CREATE_RMA: APP_PATHS.CREATE_RMA,
    USER_MASTER_LIST: APP_PATHS.USER_MASTER_LIST,
    CHOOSE_STORE_LOCATION: APP_PATHS.CHOOSE_STORE_LOCATION,
    ADMIN_MANAGE_PLANS: APP_PATHS.ADMIN_MANAGE_PLANS,
    ADMIN_MANAGE_MERCHANTS_PLANS: APP_PATHS.ADMIN_MANAGE_MERCHANTS_PLANS,
    ADMIN_MIGRATE_GLOBAL_E_MERCHANTS: APP_PATHS.ADMIN_MIGRATE_GLOBAL_E_MERCHANTS,
    ADMIN_DEV_SETTINGS: APP_PATHS.ADMIN_DEV_SETTINGS,
    EMAIL_VARIABLES_AND_EVENTS: APP_PATHS.EMAIL_VARIABLES_AND_EVENTS,
    INTEGRATIONS_BASE: APP_PATHS.INTEGRATIONS_BASE,
    WIDGETS_REPORT_SHIPMENT: APP_PATHS.WIDGETS_REPORT_SHIPMENT,
    WIDGETS_REPORT_BILLING: APP_PATHS.WIDGETS_REPORT_BILLING,
    WIDGETS_REPORT_RETURNS: APP_PATHS.WIDGETS_REPORT_RETURNS,
    WIDGETS_REPORT_TRACKING: APP_PATHS.WIDGETS_REPORT_TRACKING,
    RICH_EDITOR: APP_PATHS.RICH_EDITOR,
    SECRET_POPUP_PATH: APP_PATHS.SECRET_POPUP_PATH,
    EXAMPLES_CHECKBOXES_TREE_DROPDOWN: APP_PATHS.EXAMPLES_CHECKBOXES_TREE_DROPDOWN,
    ONBOARDING: APP_PATHS.ONBOARDING,
} as const;

export type SPA_APP_PATH_PATTERN = typeof SPA_APP_PATH_PATTERN[keyof typeof SPA_APP_PATH_PATTERN];

const PATH_MAPPING: {[key in SPA_APP_PATH_PATTERN]:LARAVEL_APP_PATH_PATTERN} = {
    [SPA_APP_PATH_PATTERN.DASHBOARD]: LARAVEL_APP_PATH_PATTERN.DASHBOARD,
    [SPA_APP_PATH_PATTERN.RETURNS]: LARAVEL_APP_PATH_PATTERN.SETTINGS_RETURNS,
    [SPA_APP_PATH_PATTERN.RETURNS_NEW]: LARAVEL_APP_PATH_PATTERN.SETTINGS_RETURNS_NEW,
    [SPA_APP_PATH_PATTERN.SETTINGS_GENERAL]: LARAVEL_APP_PATH_PATTERN.SETTINGS_GENERAL,
    [SPA_APP_PATH_PATTERN.SETTINGS_LANGUAGES]: LARAVEL_APP_PATH_PATTERN.SETTINGS_LANGUAGES,
    [SPA_APP_PATH_PATTERN.SHIP_BY_RETURNGO]: LARAVEL_APP_PATH_PATTERN.SHIP_BY_RETURNGO,
    [SPA_APP_PATH_PATTERN.RETURN_COVERAGE]: LARAVEL_APP_PATH_PATTERN.RETURN_COVERAGE,
    [SPA_APP_PATH_PATTERN.SETTINGS_RETURN_REASONS]: LARAVEL_APP_PATH_PATTERN.SETTINGS_RETURN_REASONS,
    [SPA_APP_PATH_PATTERN.SETTINGS_RESOLUTIONS]: LARAVEL_APP_PATH_PATTERN.SETTINGS_RESOLUTIONS,
    [SPA_APP_PATH_PATTERN.SETTINGS_RETURN_METHODS]: LARAVEL_APP_PATH_PATTERN.SETTINGS_RETURN_METHODS,
    [SPA_APP_PATH_PATTERN.SETTINGS_RETURN_POLICIES]: LARAVEL_APP_PATH_PATTERN.SETTINGS_RETURN_POLICIES,
    [SPA_APP_PATH_PATTERN.SETTINGS_PORTAL_CONTENT]: LARAVEL_APP_PATH_PATTERN.SETTINGS_PORTAL_CONTENT,
    [SPA_APP_PATH_PATTERN.SETTINGS_PORTAL_LOOK_AND_FEEL]: LARAVEL_APP_PATH_PATTERN.SETTINGS_PORTAL_LOOK_AND_FEEL,
    [SPA_APP_PATH_PATTERN.SETTINGS_EMAILS_CONTENT]: LARAVEL_APP_PATH_PATTERN.SETTINGS_EMAILS_CONTENT,
    [SPA_APP_PATH_PATTERN.SETTINGS_EMAILS_LOOK_AND_FEEL]: LARAVEL_APP_PATH_PATTERN.SETTINGS_EMAILS_LOOK_AND_FEEL,
    [SPA_APP_PATH_PATTERN.SETTINGS_EMAILS_NOTIFICATIONS]: LARAVEL_APP_PATH_PATTERN.SETTINGS_EMAILS_NOTIFICATIONS,
    [SPA_APP_PATH_PATTERN.SETTINGS_INTEGRATIONS]: LARAVEL_APP_PATH_PATTERN.SETTINGS_INTEGRATIONS,
    [SPA_APP_PATH_PATTERN.SETTINGS_API]: LARAVEL_APP_PATH_PATTERN.SETTINGS_API,
    [SPA_APP_PATH_PATTERN.BACK_TO_SYS_ADMIN]: LARAVEL_APP_PATH_PATTERN.BACK_TO_SYS_ADMIN,
    [SPA_APP_PATH_PATTERN.PROFILE]: LARAVEL_APP_PATH_PATTERN.PROFILE,
    [SPA_APP_PATH_PATTERN.BILLING]: LARAVEL_APP_PATH_PATTERN.BILLING,
    [SPA_APP_PATH_PATTERN.SUBSCRIPTION_PLANS]: LARAVEL_APP_PATH_PATTERN.SUBSCRIPTION_PLANS,
    [SPA_APP_PATH_PATTERN.STORE_ACCOUNTS]: LARAVEL_APP_PATH_PATTERN.STORE_ACCOUNTS,
    [SPA_APP_PATH_PATTERN.TROUBLESHOOTING]: LARAVEL_APP_PATH_PATTERN.TROUBLESHOOTING,
    [SPA_APP_PATH_PATTERN.ANALYTICS_RETURNS]: LARAVEL_APP_PATH_PATTERN.ANALYTICS_RETURNS,
    [SPA_APP_PATH_PATTERN.ANALYTICS_ORDERS]: LARAVEL_APP_PATH_PATTERN.ANALYTICS_ORDERS,
    [SPA_APP_PATH_PATTERN.ANALYTICS_SESSIONS]: LARAVEL_APP_PATH_PATTERN.ANALYTICS_SESSIONS,
    [SPA_APP_PATH_PATTERN.ANALYTICS_CREDITS]: LARAVEL_APP_PATH_PATTERN.ANALYTICS_CREDITS,
    [SPA_APP_PATH_PATTERN.ANALYTICS_TRANSACTIONS]: LARAVEL_APP_PATH_PATTERN.ANALYTICS_TRANSACTIONS,
    [SPA_APP_PATH_PATTERN.ANALYTICS_SHIPMENTS]: LARAVEL_APP_PATH_PATTERN.ANALYTICS_SHIPMENTS,
    [SPA_APP_PATH_PATTERN.ACCOUNT_HEALTH_PAGE]: LARAVEL_APP_PATH_PATTERN.ACCOUNT_HEALTH_PAGE,
    [SPA_APP_PATH_PATTERN.LOCALIZATION_STOREFRONT]: LARAVEL_APP_PATH_PATTERN.LOCALIZATION_STOREFRONT,
    [SPA_APP_PATH_PATTERN.LOCALIZATION_RETURN_PORTAL]: LARAVEL_APP_PATH_PATTERN.LOCALIZATION_RETURN_PORTAL,
    [SPA_APP_PATH_PATTERN.LOCALIZATION_RETURN_METHODS]: LARAVEL_APP_PATH_PATTERN.LOCALIZATION_RETURN_METHODS,
    [SPA_APP_PATH_PATTERN.LOCALIZATION_EMAILS]: LARAVEL_APP_PATH_PATTERN.LOCALIZATION_EMAILS,
    [SPA_APP_PATH_PATTERN.LOCALIZATION_TRACKING_EMAILS]: LARAVEL_APP_PATH_PATTERN.LOCALIZATION_TRACKING_EMAILS,
    [SPA_APP_PATH_PATTERN.CREATE_RMA]: LARAVEL_APP_PATH_PATTERN.CREATE_RMA,
    [SPA_APP_PATH_PATTERN.USER_MASTER_LIST]: LARAVEL_APP_PATH_PATTERN.USER_MASTER_LIST,
    [SPA_APP_PATH_PATTERN.CHOOSE_STORE_LOCATION]: LARAVEL_APP_PATH_PATTERN.CHOOSE_STORE_LOCATION,
    [SPA_APP_PATH_PATTERN.ADMIN_MANAGE_PLANS]: LARAVEL_APP_PATH_PATTERN.ADMIN_MANAGE_PLANS,
    [SPA_APP_PATH_PATTERN.ADMIN_MANAGE_MERCHANTS_PLANS]: LARAVEL_APP_PATH_PATTERN.ADMIN_MANAGE_MERCHANTS_PLANS,
    [SPA_APP_PATH_PATTERN.ADMIN_MIGRATE_GLOBAL_E_MERCHANTS]: LARAVEL_APP_PATH_PATTERN.ADMIN_MIGRATE_GLOBAL_E_MERCHANTS,
    [SPA_APP_PATH_PATTERN.ADMIN_DEV_SETTINGS]: LARAVEL_APP_PATH_PATTERN.ADMIN_DEV_SETTINGS,
    [SPA_APP_PATH_PATTERN.EMAIL_VARIABLES_AND_EVENTS]: LARAVEL_APP_PATH_PATTERN.SETTINGS_EMAILS_VARIABLES_AND_EVENTS,
    [SPA_APP_PATH_PATTERN.INTEGRATIONS_BASE]: LARAVEL_APP_PATH_PATTERN.SETTINGS_INTEGRATIONS_BASE,
    [SPA_APP_PATH_PATTERN.WIDGETS_REPORT_SHIPMENT]: LARAVEL_APP_PATH_PATTERN.WIDGETS_REPORT_SHIPMENT,
    [SPA_APP_PATH_PATTERN.WIDGETS_REPORT_BILLING]: LARAVEL_APP_PATH_PATTERN.WIDGETS_REPORT_BILLING,
    [SPA_APP_PATH_PATTERN.WIDGETS_REPORT_RETURNS]: LARAVEL_APP_PATH_PATTERN.WIDGETS_REPORT_RETURNS,
    [SPA_APP_PATH_PATTERN.WIDGETS_REPORT_TRACKING]: LARAVEL_APP_PATH_PATTERN.WIDGETS_REPORT_TRACKING,
    [SPA_APP_PATH_PATTERN.RICH_EDITOR]: LARAVEL_APP_PATH_PATTERN.ADMIN_DEV_SETTINGS,
    [SPA_APP_PATH_PATTERN.SECRET_POPUP_PATH]: LARAVEL_APP_PATH_PATTERN.DASHBOARD,
    [SPA_APP_PATH_PATTERN.EXAMPLES_CHECKBOXES_TREE_DROPDOWN]: LARAVEL_APP_PATH_PATTERN.ADMIN_DEV_SETTINGS,
    [SPA_APP_PATH_PATTERN.ONBOARDING]: LARAVEL_APP_PATH_PATTERN.ONBOARDING,
}

/**
 * Coordinates URL Path and Search Params changes between SPA application and Laravel application.
 */
class PageUrlCoordinationStore {
    private _searchParamsToExclude = ['uuid', 'rms-version'];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get _iframeService(): IframeService { return rootContainer.get<IframeService>(TYPE.IframService); }

    private _findSPAPathPattern(path: string): { pattern: SPA_APP_PATH_PATTERN, subPath?: string } | null {
        for (const pathPattern of Object.values(SPA_APP_PATH_PATTERN)) {
            const regExpPattern = new RegExp(`^(?<pattern>${pathPattern})(?<subPath>.*)`);
            const match = regExpPattern.exec(path)?.groups;

            if (match) {
                return {
                    pattern: match.pattern as SPA_APP_PATH_PATTERN,
                    subPath: match.subPath,
                };
            }
        }

        return null;
    }

    private _constructLaravelPath(path: string): string | null {
        const spaPathPattern = this._findSPAPathPattern(path);

        if (!spaPathPattern) {
            return null;
        }

        const laravelPathPattern = PATH_MAPPING[spaPathPattern.pattern];

        if (!laravelPathPattern) {
            console.error(`should never happen! no laravel path mapping found for SPA path pattern: ${spaPathPattern.pattern}`);
            return null;
        }

        /** Special case for RMA Page, remove rma id from path segments, since it is there in search params */
        if (
            laravelPathPattern === LARAVEL_APP_PATH_PATTERN.SETTINGS_RETURNS ||
            laravelPathPattern === LARAVEL_APP_PATH_PATTERN.SETTINGS_RETURNS_NEW
        ) {
            return laravelPathPattern;
        }

        return `${laravelPathPattern}${spaPathPattern.subPath}`;
    }

    public constructLaravelUrl(internalPath: string): string {
        const externalLaravelPath = this._constructLaravelPath(internalPath);
        return externalLaravelPath ?? '/UNDEFINED_PATH';
    }

    /** the method returns absolute laravel external URL, if specific internal route was not mapped to external - the url will show UNDEFINED_PATH */
    public constructLaravelAbsoluteUrl(internalPath: string): string {
        return `${config.apiUrl}${this.constructLaravelUrl(internalPath)}`;    
    }

    private _filterAndStringifySearchParams(searchParams: URLSearchParams): string {
        const newUrlSearchParams = new URLSearchParams();
        for (const [key, value] of searchParams) {
            if (!this._searchParamsToExclude.includes(key)) {
                newUrlSearchParams.append(key, value);
            }
        }
        return newUrlSearchParams.toString();
    }

    public changeParentPath(path: string, searchParams?: URLSearchParams): void
    {
        const laravelAppPath = this._constructLaravelPath(path as SPA_APP_PATH_PATTERN);

        if (!laravelAppPath) {
            return;
        }

        const searchParamsToAppend = (searchParams && this._filterAndStringifySearchParams(searchParams)) || '';
        this._iframeService.changeParentPath(laravelAppPath + (searchParamsToAppend ? `?${searchParamsToAppend}` : ''));
    }

    public subscribeToBrowserHistoryBackNavigation(fn: () => void): () => void {
        return this._iframeService.subscribeToParentEvent(LARAVEL_TYPE.BROWSER_BACK_BUTTON_CLICKED, fn);
    }

}

const pageUrlCoordinationStore = new PageUrlCoordinationStore();
export default pageUrlCoordinationStore;
